import { render, staticRenderFns } from "./PictureCompBackdrop.vue?vue&type=template&id=b2f80a3c&scoped=true"
import script from "./PictureCompBackdrop.vue?vue&type=script&setup=true&lang=ts"
export * from "./PictureCompBackdrop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PictureCompBackdrop.vue?vue&type=style&index=0&id=b2f80a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f80a3c",
  null
  
)

export default component.exports